import { API_STATUSES } from "../../_helpers/statuses";
import { API_CALLS } from "../_commonApiCalls/siteApi";
import {
    getV4GraphicsSiteStatus,
    getV4GraphicsSiteData,
    setV3GraphicsSiteStatus,
    setV3GraphicsSiteData
} from "../_commonReducers/siteReducers";

// ======================================================== Headers Configuration Start ================================== //
export const headersConfigData = () => {
    const credentialsData = localStorage.getItem("vkey");
    return {
        "Content-Type": "application/json",
        Authorization: "Basic " + credentialsData,
    };
};

// ======================================================== Headers Configuration End ==================================== //

const getV4GraphicsSiteService = (siteId) => {
    return async function getV4GraphicsSite(dispatch) {
        dispatch(getV4GraphicsSiteStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getV4GraphicsSiteApiCall(siteId, headersConfigData);
            let jsonResponse = await response.json();

            dispatch(getV4GraphicsSiteData(jsonResponse));
            dispatch(getV4GraphicsSiteStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getV4GraphicsSiteStatus(err));
            dispatch(getV4GraphicsSiteStatus(API_STATUSES.ERROR));
        }
    }
}

const saveV3GraphicsSiteService = (siteId, request) => {
    return async function setV3GraphicsSite(dispatch) {
        dispatch(setV3GraphicsSiteStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.setV3GraphicsSiteApiCall(siteId, request, headersConfigData);
            let jsonResponse = await response.json();

            dispatch(setV3GraphicsSiteData(jsonResponse));
            dispatch(setV3GraphicsSiteStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(setV3GraphicsSiteStatus(err));
            dispatch(setV3GraphicsSiteStatus(API_STATUSES.ERROR));
        }
    }
}

export const SITE_SERVICES = {
    getV4GraphicsSiteService,
    saveV3GraphicsSiteService
};
